import React, { useState } from "react";
import cn from "classnames";
import styles from "./SignIn.module.sass"; // Assurez-vous que ce chemin est correct
import { use100vh } from "react-div-100vh";
import { Link } from "react-router-dom";
import TextInput from "../../components/TextInput";
import Image from "../../components/Image";
import { toast } from "react-toastify";
import { pb } from "../../services/pocketbase";// Importez pb depuis votre fichier services

const RequestPasswordReset = () => {
  const heightWindow = use100vh();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false); // Nouveau état pour confirmer l'envoi

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Appel à l'API PocketBase pour demander la réinitialisation avec URL personnalisée
      await pb.collection('users').requestPasswordReset(email, {
        emailTemplate: 'password_reset',
        // Cette URL doit pointer vers votre page Front-end de réinitialisation
        actionUrl: `${window.location.origin}/reset-password?token={TOKEN}`
      });
      setEmailSent(true); // Mettre à jour l'état après un envoi réussi
      toast.success("Un email de réinitialisation a été envoyé à votre adresse.");
    } catch (error) {
      console.error("Erreur lors de la demande de réinitialisation:", error);
      toast.error("Échec de l'envoi de l'email de réinitialisation. Vérifiez l'adresse.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.row}>
      <div
        className={styles.col}
        style={{
          backgroundImage: `url('/images/content/loginbg.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '100vh',
          flex: 1
        }}
      />
      <div className={styles.col} style={{ minHeight: heightWindow, flex: 1.5}}>
        <div className={styles.head}>
          <Link className={styles.logo} to="/">
            <Image
              className={styles.pic}
              src="/images/logo.png"
              srcDark="/images/logo.png"
              alt="Core"
            />
          </Link>
          <div className={styles.info}>
            Vous avez déjà un compte ?{" "} {/* Texte ajusté */}
            <Link className={styles.link} to="/sign-in"> {/* Lien vers la page de connexion */}
              Connectez-vous
            </Link>
          </div>
        </div>
        <div className={styles.wrapper}>
          <div className={cn("h2", styles.title)}>Mot de passe oublié</div>
          <div className={styles.body}>
            {emailSent ? (
              <p>Si l'adresse email existe dans notre système, vous recevrez un lien de réinitialisation. Veuillez vérifier votre boîte de réception (et vos spams).</p>
            ) : (
              <form onSubmit={handleSubmit}>
                <TextInput
                  className={styles.field}
                  name="email"
                  type="email"
                  placeholder="Votre email de récupération"
                  required
                  icon="mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button
                  className={cn("button", styles.button)}
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Envoi en cours..." : "Envoyer le lien de réinitialisation"}
                </button>
              </form>
            )}
            <div className={styles.note}>
              <p>Un lien de réinitialisation sera envoyé à cette adresse email.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestPasswordReset;